import {getBuildingRepairer} from '../../api/workOrder'

const workOrder = {
    namespaced: true,
    state: {
        list: [],
        totalCount: 0,
        pageSize: 20,
        currentPage: 1,
        pageSizeOpts: [10, 20, 30, 40, 50],
        workOrderInfo: {},
        shangMenRecords: [],
        memberPermission: {},
        managementActive: 0
        // buildingRepairerInfo: {}
        // cityList: []
    },
    mutations: {
        setPageSize(state, size) {
            state.pageSize = size;
        },
        setCurrentPage(state, page) {
            state.currentPage = page;
        },
        setManagementActive(state, active) {
            state.managementActive = active;
        }
    },
    actions: {
        async getAll({state}, payload) {
            let page = payload.data;
            page.maxResultCount = state.pageSize;
            page.skipCount = (state.currentPage - 1) * state.pageSize;
            let rep = await abp.ajax.post('/api/services/app/WorkOrder/SearchWorkOrders', page);
            state.list = [];
            state.list.push(...rep.data.result.items);
            state.totalCount = rep.data.result.totalCount;
        },
        async getWorkOrderById({state}, payload) {
            let rep = await abp.ajax.get('/api/services/app/WorkOrder/GetWorkOrderById?id=' + payload.id);
            state.workOrderInfo = {};
            state.workOrderInfo = rep.data.result;
        },
        async saveWorkOrder({state}, payload) {
            await abp.ajax.post('/api/services/app/WorkOrder/SaveWorkOrder', payload.data);
        },
        async getShangMenRecords({state}, payload) {
            let req = await abp.ajax.get('/api/services/app/WorkOrder/GetShangMenRecords?paiDanId=' + payload.id);
            state.shangMenRecords = [];
            state.shangMenRecords.push(...req.data.result);
        },
        async memberPermission({state}, payload) {
            let req = await abp.ajax.post('/api/services/app/WorkOrder/MCheckerPermissionByWorkOrder?workOrderId=' + payload.id);
            state.memberPermission = {};
            state.memberPermission = req.data.result;
        },
        // async getBuildingRepairer({state}, payload) {
        //     let rep = await getBuildingRepairer(payload.id);
        //     state.buildingRepairerInfo = {};
        //     state.buildingRepairerInfo = rep.data.result;
        // }

    }
};
export default workOrder;
